import React from 'react';
import { Link } from 'react-router-dom';

/** Old free-text insurance company, read-only, with links to the structured Insurance section on the profile. */
const LegacyInsurance = ({ text, patientId }) => (
    <div className="mb-2" data-testid="legacy-insurance">
        <label className="form-label mt-3">Legacy insurance text</label>
        <input className="form-control shadow-none" value={text || ''} readOnly disabled placeholder="—" />
        {patientId ? (
            <small>
                <Link to={{ pathname: '/patientprofile', state: { patientid: patientId }, hash: '#insurance' }}>Insurance section (payer picker)</Link>
                {text ? (
                    <>
                        {' · '}
                        <Link to={{ pathname: '/patientprofile', state: { patientid: patientId, insurancePrefill: text }, hash: '#insurance' }}>
                            Create insurance from this
                        </Link>
                    </>
                ) : null}
            </small>
        ) : (
            <small className="text-muted">Add structured insurance on the patient profile after saving.</small>
        )}
    </div>
);

export default LegacyInsurance;
